export default __webpack_public_path__ + "static/media/gync-form-icon.e3e972b1.svg";